import actionTypes from 'SRC/modules/redux/actionTypes'

export const setAdditionalLoading = isLoading => ({
  type: actionTypes.SET_USERS_LIST_ADDITIONAL_LOADING,
  payload: isLoading
})
